import { analyticsUtils } from 'utils/analytics-utils';
import { TMaterialFormState } from '../pages/surface/store/hooks/material';
import { SurfaceInputs, TSurfaces } from '../pages/surface/types';

const completeVariant = ({
  obj,
  hasMaterial,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  obj: any;
  hasMaterial: boolean;
}) =>
  Object.keys(obj).reduce(
    (acc, key, i) =>
      acc.concat(
        i !== 0 ? ' / ' : '',
        hasMaterial ? `${obj[key].name} - ${obj[key].value}` : `${obj[key].label}`
      ),
    ''
  );

/**
 * Событие должно срабатывать при клике на кнопку "Далее" на первом шаге.
 */
export const gaClickSurfaceStep = ({
  materialState,
  surfaceFormData,
  surfaces,
}: {
  materialState: TMaterialFormState;
  surfaceFormData: SurfaceInputs;
  surfaces: TSurfaces;
}) => {
  const variant = completeVariant({ obj: materialState, hasMaterial: true });
  const variantWithoutMaterials = completeVariant({
    obj: surfaces.length > 1 ? surfaces.filter(surf => surfaceFormData[surf.name]) : surfaces,
    hasMaterial: false,
  });
  return analyticsUtils.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock: 'productDetail / calc',
    elementName: 'Какие поверхности вас интересуют?',
    elementText: 'Далее',
    elementVariant: materialState?.length ? variant : variantWithoutMaterials, // выбранные варианты ответа через / + выбранные подпункты через “,”, разделенные тире (при клике по стрелочке “Вернуться назад” не передается параметр)
  });
};
